export const dealShowEn = {
  demo: {
    title: "Demo",
    none: "No demo scheduled.",
    schedule: "Schedule a demo",
    join: "Join the Teams demo",
    edit: "Edit the demo",
    cancel: "Cancel the demo",
    cancel_title: "Cancel the demo?",
    cancel_body: "The date and Teams link will be removed from the deal.",
    confirm: "Confirm",
    cancelled: "Demo cancelled.",
    cancel_failed: "Could not cancel the demo.",
    held: "Demo held",
  },
  emails: {
    title: "Emails",
    empty: "No emails for this deal.",
    error: "Emails unavailable.",
  },
  history: {
    title: "Stage history",
    created: "Created",
    empty: "No stage changes.",
    error: "History unavailable.",
  },
  outcome: {
    won_on: "Won on %{date}",
    lost_because: "Lost: %{reason}",
  },
  source: "Source",
  retry: "Retry",
};
